/**
 * Splits a work title into a main title and a small subtitle.
 *
 * Editors add a trailing parenthetical to titles in the admin, e.g.
 *   "Atlas x Gianni Pettena (w/ Benjamin di Falco)"
 *   "Atlas x Gianni Pettena (for Forniture Pallotta)"
 * The parenthetical is rendered as a smaller subtitle under the title.
 * Nested parentheses inside the suffix are preserved ("Timeo (†*)").
 */
export function parseWorkTitle(title: string): { mainTitle: string; subtitle: string } {
    const trimmed = title.trim();
    if (!trimmed.endsWith(')')) return { mainTitle: trimmed, subtitle: '' };

    // Walk backwards to find the "(" that matches the final ")".
    let depth = 0;
    let open = -1;
    for (let i = trimmed.length - 1; i >= 0; i--) {
        const ch = trimmed[i];
        if (ch === ')') depth++;
        else if (ch === '(') {
            depth--;
            if (depth === 0) { open = i; break; }
        }
    }
    // Unbalanced, or the whole title is a parenthetical: leave as is.
    if (open <= 0) return { mainTitle: trimmed, subtitle: '' };

    const mainTitle = trimmed.slice(0, open).trim();
    const subtitle = trimmed.slice(open + 1, -1).trim();
    if (!mainTitle || !subtitle) return { mainTitle: trimmed, subtitle: '' };
    return { mainTitle, subtitle };
}
